// extracted by mini-css-extract-plugin
export default {"modal-body":"offerCard_modal-body__nu8AS","active-day":"offerCard_active-day__NxDJK","slots-area":"offerCard_slots-area__hL1vP"};